module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Michael Hugh Soady was born in West Looe, Cornwall, on September 19, 1937, the eldest son of a 6th-generation Cornish fisherman. Michael was educated at Looe School, Liskeard Grammar School and Devonport Engineering College. He was conscripted into the British army from February 1960 to January 1962, serving as a non-commissioned officer in the Corps of Royal Military Police. After demobilisation, Michael held the post of a leading draughtsman for the admiralty armament supply officer.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_c('em', [_vm._v("Endeavour to Be a Cornish Fisherman")]), _vm._v(" follows on from his memoirs in his first book, "), _c('em', [_vm._v("An Unlikely Cornish Fisherman")]), _vm._v(", and covers Michael’s life experiences during the period 1963–1972.")]), _vm._v(" "), _c('p', {
    staticClass: "iim",
    staticStyle: {
      "text-align": "center",
      "margin-top": "25px",
      "margin-bottom": "25px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "3.74587in",
      "height": "2.59215in",
      "filter": "grayscale(100%)"
    },
    attrs: {
      "alt": "",
      "src": "media/file0.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Aerial photo of Looe harbour")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0